import React from "react";
import {
  Box, Checkbox, Divider, FormControl, FormControlLabel,
  FormGroup, FormLabel, Grid, TextField, Typography,
} from "@mui/material";

const VASCULAR_RISK_OPTIONS = [
  "Hipertensión",
  "Dislipidemia",
  "Diabetes mellitus",
  "Trastornos metabólicos",
  "Trastornos respiratorios",
  "Condiciones traumáticas",
  "Condiciones posquirúrgicas",
  "Trastornos musculoesqueléticos degenerativos",
  "Trastornos musculoesqueléticos degenerativos crónicos",
  "Dolor / limitaciones funcionales",
  "Trastornos degenerativos",
  "Trastornos psiquiátricos",
  "Cáncer",
  "Otros",
];

const PREVIOUS_EVENTS_OPTIONS = [
  "Ictus isquémico",
  "Ictus hemorrágico",
  "AIT",
];

const COMORBIDITIES_OPTIONS = [
  "Deterioro cognitivo",
  "Otras enfermedades neurológicas",
  "Depresión / Ansiedad",
];

function CheckboxGroup({ options, selected, onChange }) {
  const toggle = (option) => {
    const next = selected.includes(option)
      ? selected.filter((o) => o !== option)
      : [...selected, option];
    onChange(next);
  };

  return (
    <FormGroup>
      <Grid container>
        {options.map((opt) => (
          <Grid item xs={12} sm={6} key={opt}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selected.includes(opt)}
                  onChange={() => toggle(opt)}
                  size="small"
                />
              }
              label={opt}
            />
          </Grid>
        ))}
      </Grid>
    </FormGroup>
  );
}

export default function PremorbidInfo({ form, onChange, onCheckboxChange }) {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
        Información Premórbida
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        {/* Factores de riesgo vascular */}
        <Grid item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel sx={{ mb: 1, fontWeight: 600 }}>
              Historia médica — Factores de riesgo vascular
            </FormLabel>
            <CheckboxGroup
              options={VASCULAR_RISK_OPTIONS}
              selected={form.vascular_risk_factors}
              onChange={(val) => onCheckboxChange("vascular_risk_factors", val)}
            />
          </FormControl>
        </Grid>

        {/* Eventos previos */}
        <Grid item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel sx={{ mb: 1, fontWeight: 600 }}>Eventos previos</FormLabel>
            <CheckboxGroup
              options={PREVIOUS_EVENTS_OPTIONS}
              selected={form.previous_events}
              onChange={(val) => onCheckboxChange("previous_events", val)}
            />
          </FormControl>
        </Grid>

        {/* Comorbilidades */}
        <Grid item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <FormLabel sx={{ mb: 1, fontWeight: 600 }}>
              Enfermedades / Comorbilidades concomitantes
            </FormLabel>
            <CheckboxGroup
              options={COMORBIDITIES_OPTIONS}
              selected={form.comorbidities}
              onChange={(val) => onCheckboxChange("comorbidities", val)}
            />
          </FormControl>
        </Grid>

        {/* Estado de independencia (MRS) */}
        <Grid item xs={12} sm={4}>
          <TextField
            label="Estado de independencia (MRS 0–6)"
            name="independence_status"
            type="number"
            value={form.independence_status}
            onChange={onChange}
            fullWidth
            inputProps={{ min: 0, max: 6 }}
            helperText="Modified Rankin Scale premórbida"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
